import React from 'react'
import { useRouter } from 'next/router';
import Link from 'next/link'
import styles from './custom_card.module.css'
import strings from '../../strings/strings.json'

export default function CustomCard(props) {
    const router = useRouter()

    return (
        <div
            className={styles.custom_card_parent} >
            <div
                className={styles.img_container}>
                <img
                    className={styles.img}
                    alt="imageContainer"
                    src={props.data.file_icon ?
                        `data:image/png;base64, ${props.data.file_icon}`
                        :
                        "/assets/icons/android.png"
                    }
                />
            </div>
            <span className={`${styles.app_name} englishIranSans`}>{props.data.program_name}</span>
            <span className={styles.pck}>{props.data.package_name}</span>
            <div className={styles.btn}>
                <Link
                    href={{
                        pathname: "/file/[packagename]/[md5]",
                        query: {
                            packagename: props.data.package_name,
                            md5: props.data.md5
                        }
                    }}
                >
                    <a className={styles.text_container}>{strings.appList_showDetails}</a>
                </Link>
            </div>
        </div>
    )
}